import * as contractStatuses from 'constants/enums/requestLeaseContractStatuses'

export default {
  [contractStatuses.NEW]: 'Nová',
  [contractStatuses.PENDING_SIGNATURE]: 'Na podpis',
  [contractStatuses.REALIZED]: 'Realizovaná',
  [contractStatuses.NOT_REALIZED]: 'Nerealizovaná',
}
